module.exports = __webpack_public_path__ + "img/mobile/SmartButton-auto/btn-skip-portrait-up@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/SmartButton-auto/btn-skip-portrait-up@3x.png
// module id = 742
// module chunks = 0